import { TFormErrorProps } from '@/types/types';
import { cn } from '@/lib/utils';
import DOMPurify from 'isomorphic-dompurify';
import { TriangleAlertIcon } from 'lucide-react';

export function FormError({
    message,
    classes,
    messageStyle,
    iconStyle,
    children,
}: TFormErrorProps) {
    if (!message) {
        return null;
    }
    return (
        <div
            id='form_error'
            className={cn(
                'flex flex-col items-center w-full gap-4 rounded-md bg-destructive/10 p-3 text-sm text-destructive',
                classes,
            )}>
            <TriangleAlertIcon className={cn('h-8 w-8', iconStyle)} />
            <p
                className={cn(
                    'text-center text-[0.9rem] md:text-[1rem]',
                    messageStyle,
                )}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(message, {
                        USE_PROFILES: { html: true },
                    }),
                }}></p>
            {children}
        </div>
    );
}
